import base from './classes'
import { cloneDeep } from 'lodash'

const derived = cloneDeep(base)

derived.getters.controllerDefaultParams = () => ({ fetch: { has_overrides: true } })

export default derived
